/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'

export default function  AlreadyExists({handleSidePopupClick, setAlreadyExit, selectedMonth}) {
    return (
        <>
            <div className='px-[20px] pb-[110px] border-b border-[#E6E8EA]' style={{'padding-top':'130px'}}>
                <p className='text-f2 text-[#031624]'>
                    {`Payroll for ${JSON.parse(localStorage.getItem('FY_details')).name}, Month: ${selectedMonth} already exists.`} 
                </p>
                <p className='text-f2 text-[#031624] text-center mt-5'>
                    {`Please delete it using the 'Delete' option and then re-upload the updated Payroll for '${selectedMonth}' month.`}
                </p>
            </div>
            <div class=" flex -mx-2.5 mt-5">
                <div class="w-1/2">
                    <div class="w-full flex justify-end">
                        <button 
                            onClick={() => handleSidePopupClick()}
                            type="button" 
                            id='Cancel'
                            class="cancl-btn" data-te-modal-dismiss="" aria-label="Close">Cancel</button>
                    </div>
                </div>
                <div class="w-1/2">
                    <div class="w-full">
                        <button 
                            type="button" 
                            id="upload" 
                            onClick={() => setAlreadyExit(false)}
                            // disabled={changedOngoingFY?.name === "" || changedOngoingFY.name === undefined}
                            class="actn-btn onboardInstitution" 
                            tabindex="0"
                        >Go Back</button>
                    </div>
                </div>
            </div>
        </>
    )
}
